var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",style:({ width: _vm.width })},[(_vm.link !== null)?_c('a',{attrs:{"href":_vm.link}},[_c('block-m')],1):_vm._e(),(_vm.link === null)?_c('block-m'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }